import { render, staticRenderFns } from "./VBarChart.vue?vue&type=template&id=ba937e04"
import script from "./VBarChart.vue?vue&type=script&lang=js"
export * from "./VBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports